import PropTypes from "prop-types";
import {
  Content,
  Heading,
  Form,
  TextField,
  RadioGroup,
  Radio,
  ComboBox,
  ComboBoxItem,
  ButtonGroup,
  Button,
  DialogContainer,
  Dialog,
} from "@react-spectrum/s2";

import { getQueryLoadingState } from "@app/utils";

/**
 * Account details dialog shown after a template is chosen. Fully prop-driven so
 * it can be used both inside the wizard (TemplateStep / ModularTemplateStep) and
 * standalone (e.g. the home page) without the wizard context.
 */
export const AccountDetailsStep = ({
  isOpen,
  sfType,
  onSfTypeChange,
  accountName,
  onAccountNameChange,
  drNumbers,
  drNumbersFilter,
  onDrNumbersFilterChange,
  drNumber,
  onDrNumbersSelectionChange,
  onCancel,
  onContinue,
}) => {
  const isContinueDisabled =
    (sfType === "drNumber" && !drNumber) ||
    (sfType === "accountName" && !accountName);

  return (
    <DialogContainer onDismiss={onCancel}>
      {isOpen && (
        <Dialog>
          <Heading slot="title">Account details</Heading>
          <Content>
            <p>
              Enter DR Number or Account Name to track the account details or
              select &ldquo;None&rdquo; if not applicable.
            </p>
            <Form>
              <RadioGroup
                aria-label="DR Number / Account Name"
                value={sfType}
                onChange={onSfTypeChange}
                orientation="horizontal"
              >
                {/* <Radio value="drNumber">DR Number</Radio> */}
                <Radio value="accountName">DR Number / Account</Radio>
                <Radio value="none">None</Radio>
              </RadioGroup>

              {sfType === "drNumber" && drNumbers && (
                <ComboBox
                  label="DR Number"
                  description="Type at least 3 characters of a deal name or enter full DR number."
                  isRequired
                  items={drNumbers.data || []}
                  loadingState={getQueryLoadingState(drNumbers)}
                  inputValue={drNumbersFilter}
                  onInputChange={onDrNumbersFilterChange}
                  selectedKey={drNumber}
                  onSelectionChange={onDrNumbersSelectionChange}
                  menuWidth={540}
                >
                  {(item) => (
                    <ComboBoxItem
                      id={item.id}
                      textValue={`${item.drNumber} — ${item.name}`}
                    >
                      {`${item.drNumber} — ${item.name}`}
                    </ComboBoxItem>
                  )}
                </ComboBox>
              )}

              {sfType === "accountName" && (
                <TextField
                  aria-label="Account Name"
                  // description="Type the full account name."
                  isRequired
                  value={accountName}
                  onChange={onAccountNameChange}
                />
              )}
            </Form>
          </Content>
          <ButtonGroup>
            <Button variant="secondary" onPress={onCancel}>
              Cancel
            </Button>
            <Button isDisabled={isContinueDisabled} onPress={onContinue}>
              Continue
            </Button>
          </ButtonGroup>
        </Dialog>
      )}
    </DialogContainer>
  );
};

AccountDetailsStep.propTypes = {
  isOpen: PropTypes.bool,
  sfType: PropTypes.string,
  onSfTypeChange: PropTypes.func,
  accountName: PropTypes.string,
  onAccountNameChange: PropTypes.func,
  // Optional — only needed when the (currently disabled) DR Number option is used.
  drNumbers: PropTypes.object,
  drNumbersFilter: PropTypes.string,
  onDrNumbersFilterChange: PropTypes.func,
  drNumber: PropTypes.string,
  onDrNumbersSelectionChange: PropTypes.func,
  onCancel: PropTypes.func,
  onContinue: PropTypes.func,
};
